import { config } from '../../config'
import useWindowOpener from '../../hooks/use-window-opener'
import { alpha, Box, Button } from '@mui/material'
import toast from 'react-hot-toast'
import { useTheme } from '@emotion/react'
import { useSelector } from 'react-redux'
import { useConnectGoogleAccountMutation } from 'src/services/account-service'

const ConnectWithPublicDomain = ({ onCancel }) => {
  const theme = useTheme()
  const workspace = useSelector((state) => state.workspace)
  const [connectGoogleAccount] = useConnectGoogleAccountMutation()
  const isWhitelabelCustomSMTPMail = true
  const reconnect = false
  const iframe = false

  const handleOnMessage = async (event) => {
    if (event?.data?.provider === 'google_oauth') {
      closeWindow()
      const { code } = event.data
      const toastId = toast.loading('Loading...', { duration: Infinity })
      try {
        const { message } = await connectGoogleAccount({ reconnect, code: { code, workspace, isWhitelabelCustomSMTPMail }, iframe }).unwrap()
        toast.success(message, { id: toastId, duration: 2000 })
      } catch (error) {
        toast.error(error?.data?.error?.message || 'something went wroung', { id: toastId, duration: 2000 })
      }
    } else if (event?.data?.provider === 'microsoft_oauth') {
      closeWindow()
    }
  }

  const { openWindow, closeWindow } = useWindowOpener({ onMessage: handleOnMessage })

  const handleConnectGoogleAccount = async () => {
    const redirectUri = `${window.location.origin}/oauth/google/redirect`
    const params = new URLSearchParams({
      redirect_uri: redirectUri,
      client_id: config.GOOGLE_OAUTH_CLIENT_ID,
      access_type: 'offline',
      response_type: 'code',
      prompt: 'consent',
      scope: config.GOOGLE_OAUTH_SCOPE
    })

    const url = `${config.GOOGLE_OAUTH_AUTH_URL}?${params.toString()}`
    openWindow(url)
  }

  const handleConnectMicrosoftAccount = async () => {
    const customParams = {
      workspaceId: workspace?._id,
      iframe,
      isWhitelabelCustomSMTPMail
    }
    const state = JSON.stringify(customParams)
    const params = new URLSearchParams({
      client_id: config.MICROSOFT_OAUTH_CLIENT_ID,
      scope: config.MICROSOFT_OAUTH_SCOPE,
      redirect_uri: config.MICROSOFT_OAUTH_REDIRECT_URI,
      response_mode: 'query',
      response_type: 'code',
      prompt: 'login',
      state
    })
    const url = `${config.MICROSOFT_OAUTH_AUTHORIZATION_URL}?${params.toString()}`
    openWindow(url)
  }

  const handleGoogleConnect = () => {
    handleConnectGoogleAccount()
  }

  const handleHotMailConnect = () => {
    handleConnectMicrosoftAccount()
  }

  return (
    <Box gap={3} display='flex' flexDirection='row' sx={{ mb: 3 }}>
      <Button
        variant='contained'
        style={{
          height: 30
        }}
        sx={{
          bgcolor: theme.palette.primary.main,
          '&:hover': {
            bgcolor: alpha(theme.palette.primary.main, 0.9)
          }
        }}
        type='button' onClick={handleGoogleConnect}
      >
        <Box>
          Connect With Google
        </Box>
      </Button>
      <Button
        style={{
          height: 30
        }}
        variant='contained'
        sx={{
          bgcolor: theme.palette.primary.main,
          '&:hover': {
            bgcolor: alpha(theme.palette.primary.main, 0.9)
          }
        }}
        type='button' onClick={handleHotMailConnect}
      >
        <Box>
          Connect With Hotmail/Outlook
        </Box>
      </Button>

      <Button
        style={{
          height: 30
        }}
        variant='contained'
        sx={{
          bgcolor: theme.palette.error.main,
          '&:hover': {
            bgcolor: alpha(theme.palette.error.light, 0.9)
          }
        }}
        type='button' onClick={onCancel}
      >
        <Box>
          Cancel
        </Box>
      </Button>
    </Box>
  )
}

export default ConnectWithPublicDomain
